/**
 * Undo/Redo history manager for the email builder.
 * Stores deep-cloned snapshots of the blocks array.
 */
export default function HistoryManager(maxSteps) {
	this._stack = []
	this._index = -1
	this._maxSteps = maxSteps || 50
}

HistoryManager.prototype.push = function(state) {
	// Discard any redo states after current position
	if (this._index < this._stack.length - 1) {
		this._stack = this._stack.slice(0, this._index + 1)
	}

	this._stack.push(JSON.parse(JSON.stringify(state)))
	this._index = this._stack.length - 1

	// Trim oldest entries if over limit
	if (this._stack.length > this._maxSteps) {
		this._stack.shift()
		this._index--
	}
}

HistoryManager.prototype.undo = function() {
	if (this._index <= 0) return null
	this._index--
	return JSON.parse(JSON.stringify(this._stack[this._index]))
}

HistoryManager.prototype.redo = function() {
	if (this._index >= this._stack.length - 1) return null
	this._index++
	return JSON.parse(JSON.stringify(this._stack[this._index]))
}

HistoryManager.prototype.canUndo = function() {
	return this._index > 0
}

HistoryManager.prototype.canRedo = function() {
	return this._index < this._stack.length - 1
}

HistoryManager.prototype.clear = function() {
	this._stack = []
	this._index = -1
}
